"use client"

import MuxPlayer from "@mux/mux-player-react"
import clsx from "clsx"

interface Props {
    playbackId: string
    title: string
    posterUrl?: string | null
    className?: string
}

export default function BlogMuxPlayer({ playbackId, title, posterUrl, className }: Props) {
    return (
        <MuxPlayer
            playbackId={playbackId}
            poster={posterUrl ?? undefined}
            streamType="on-demand"
            className={clsx("h-auto w-full", className)}
            style={{ width: "100%", backgroundColor: "transparent" }}
            metadata={{
                video_id: playbackId,
                video_title: title,
            }}
            primaryColor="#015389"
            secondaryColor="#e5f0f7"
        />
    )
}
